import React from 'react'
import PropTypes from 'prop-types'
import { themeColor, themeFontSize } from '../../util/themeLenses'
import Copy from '../Copy'
import Button from '../Button'
import Icon from '../Icon'
import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
    1% { opacity: 0.2; }
    100% { opacity: 1; }
`

const Number = styled(Copy)`
    animation: ${fadeIn} 1s linear;
    height: calc(${({boxSize}) => themeFontSize(boxSize)} * 2);
    line-height: calc(${({boxSize}) => themeFontSize(boxSize)} * 2);
`
Number.propTypes = {
    boxSize: PropTypes.string,
}

const ButtonGroup = styled.div`
    display: flex;
    & > * {
        display: flex;
        align-items: center;
        justify-content: center;
        justify-items: center;
        height: calc(${({boxSize}) => themeFontSize(boxSize)} * 2);
        min-width: calc(${({boxSize}) => themeFontSize(boxSize)} * 2);
    }

    button {
        border: 1px solid ${themeColor('gray60')};
        border-radius: 50%;
        background-color: ${themeColor('transparent')};
    }

    button:disabled {
        border: 1px solid ${themeColor('gray60')};
        background-color: ${themeColor('transparent')};
    }
    button:hover {
        background-color: ${themeColor('lightGray20')};
        border: 1px solid ${themeColor('gray60')};
    }


`

ButtonGroup.propTypes = {
    boxSize: PropTypes.string,
}

const NumericPicker = ({
    value,
    min,
    max,
    onChange,
    disabled,
    step,
    fontSize,
    fontColor,
    dataTest,
}) => {

    const isMinDisabled = (min !== null && value <= min) || disabled
    const isMaxDisabled = (max !== null && value >= max) || disabled

    return (<ButtonGroup boxSize={fontSize} alignItems='center' height='36px' align='center' border='1px solid red'>
        <div>
            <Button
              dataTest={`${dataTest}-unit-decrease-button`}
              disabled={isMinDisabled}
              padding='0'
              width='100%'
              height='100%'
              fontWeight='regular'
              onClick={() => onChange(value - step)}>
                <Icon fontSize={fontSize} type='less' color={isMinDisabled ? 'gray60' : 'darkGray'} />
            </Button>
        </div>
        <div>
            <Number
              key={`number_${value}`}
              padding='0 5px'
              boxSize={fontSize}
              width='100%'
              textAlign='center'
              fontSize={fontSize}
              fontColor={fontColor}
              fontWeight='regular'>
                { value }
            </Number>
        </div>
        <div>
            <Button
              dataTest={`${dataTest}-unit-increase-button`}
              disabled={isMaxDisabled}
              padding='0'
              width='100%'
              height='100%'
              fontWeight='regular'
              onClick={() => onChange(value + step)}>
                <Icon fontSize={fontSize} type='plus' color={isMaxDisabled ? 'gray60' : 'darkGray'} />
            </Button>
        </div>
    </ButtonGroup>)
}

NumericPicker.defaultProps = {
    disabled: false,
    step: 1,
    min: null,
    max: null,
    value: 1,
    fontSize: 'xLarge',
    dataTest: 'numeric-picker',
}

NumericPicker.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    disabled: PropTypes.bool,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func,
    fontSize: PropTypes.string,
    fontColor: PropTypes.string,
    dataTest: PropTypes.string,
}

export default NumericPicker
